import { TOTAL_STEPS } from './LogoStepProgress'

export interface InterviewChromeState {
  progressStep: number
  savedCount: number
  doneActive: boolean
  warmup: boolean
  frozen: boolean
  engaged: boolean
}

export interface ProgressVisualProps {
  step: number
  animate: boolean
  halo: boolean
  /** Gentler liquid rise for the desktop hub logo. */
  smoothFill: boolean
}

// Frozen: it's only ever spread-from (buildInterviewChrome) or used as an
// initial useState value, never mutated. Freezing keeps a stray write from
// leaking shared state across every interview mount.
export const INITIAL_INTERVIEW_CHROME: InterviewChromeState = Object.freeze({
  progressStep: 0,
  savedCount: 0,
  doneActive: false,
  warmup: true,
  frozen: false,
  engaged: false,
})

export function clampBuildStep(step: number): number {
  return Math.min(TOTAL_STEPS, Math.max(0, step))
}

/** Map interview phase flags + progress to logo / bar motion props. */
export function getProgressVisualProps(chrome: InterviewChromeState): ProgressVisualProps {
  const { warmup, engaged, doneActive, progressStep, frozen } = chrome
  const motion = warmup || engaged || doneActive
  const step = engaged || doneActive ? progressStep : 0
  return {
    step,
    animate: motion,
    halo: motion && !frozen,
    smoothFill: true,
  }
}

export function buildInterviewChrome(
  overrides: Partial<InterviewChromeState>
): InterviewChromeState {
  return { ...INITIAL_INTERVIEW_CHROME, ...overrides }
}

/** Mobile bar fill: six equal tiers (0 = empty, 6 = full). */
export function barFillProgress(step: number): number {
  return clampBuildStep(step) / TOTAL_STEPS
}

export const SKIP_LABEL = 'Skip'
